import React from 'react'
import OrderList from './OrderList'

function Applied({status}) {
  return (
   <OrderList status={status}/>
  )
}

export default Applied